import { ConcreteEncodable } from "./ConcreteEncodable";

import { InterventionEventImplEncoder } from "../../encoder/InterventionEventImplEncoder";

import * as CubiqTS from "../../index";
import { InterventionEvent } from "../InterventionEvent";

export class InterventionEventImpl extends ConcreteEncodable implements InterventionEvent {
  public static enType: string = "com.bcdfx.model.InterventionEventImpl";

  /*FID=1*/
  public eventId: string;
  /*FID=2*/
  public eventType: CubiqTS.InterventionEventType;
  /*FID=3*/
  public baseCode: string;
  /*FID=4*/
  public nonBaseCode: string;
  /*FID=5*/
  public currencyPair: string;
  /*FID=6*/
  public timestamp: CubiqTS.moment.Moment | null = null;
  /*FID=7*/
  public lockUserId: CubiqTS.Long | null = null;
  /*FID=8*/
  public reason: CubiqTS.DIReason;
  /*FID=9*/
  public salesGroupId: CubiqTS.Long | null = null;
  /*FID=10*/
  public traderGroupId: CubiqTS.Long | null = null;
  /*FID=11*/
  public capabilities: Array<CubiqTS.InterventionEventCapability> | null = null;
  /*FID=12*/
  public orderData: CubiqTS.OrderData | null = null;
  /*FID=13*/
  public fixingRateRequirement: CubiqTS.FixingRateRequirementData | null = null;
  /*FID=14*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=15*/
  public channelCd: string;
  /*FID=16*/
  public deal: CubiqTS.Deal | null = null;
  /*FID=17*/
  public operationType: CubiqTS.InterventionOperationType;
  /*FID=18*/
  public unLockUserId: CubiqTS.Long | null = null;
  /*FID=19*/
  public transferStatus: CubiqTS.TransferStatus;
  /*FID=20*/
  public targetTraderGroupId: CubiqTS.Long | null = null;
  /*FID=21*/
  public displayChannelName: string;
  /*FID=22*/
  public fwdRollOrderData: CubiqTS.FwdRollOrderData | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = InterventionEventImplEncoder.Instance;
    this.setEncodableType(InterventionEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "InterventionEventImpl[" +
      "eventId=" +
      this.eventId +
      "eventType=" +
      this.eventType +
      "baseCode=" +
      this.baseCode +
      "nonBaseCode=" +
      this.nonBaseCode +
      "currencyPair=" +
      this.currencyPair +
      "timestamp=" +
      this.timestamp +
      "lockUserId=" +
      this.lockUserId +
      "reason=" +
      this.reason +
      "salesGroupId=" +
      this.salesGroupId +
      "traderGroupId=" +
      this.traderGroupId +
      "capabilities=" +
      this.capabilities +
      "orderData=" +
      this.orderData +
      "fixingRateRequirement=" +
      this.fixingRateRequirement +
      "errors=" +
      this.errors +
      "channelCd=" +
      this.channelCd +
      "deal=" +
      this.deal +
      "operationType=" +
      this.operationType +
      "unLockUserId=" +
      this.unLockUserId +
      "transferStatus=" +
      this.transferStatus +
      "targetTraderGroupId=" +
      this.targetTraderGroupId +
      "displayChannelName=" +
      this.displayChannelName +
      "fwdRollOrderData=" +
      this.fwdRollOrderData +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
